import React from 'react';

export const Card = ({ children, className = '', hover = false, ...props }) => {
  return (
    <div
      className={`
        bg-white/95 backdrop-blur-sm rounded-xl shadow-soft border border-slate-200/70
        ${hover ? 'transition-all duration-300 ease-swift hover:shadow-medium hover:-translate-y-0.5' : ''}
        ${className}
      `}
      {...props}
    >
      {children}
    </div>
  );
};

export const CardHeader = ({ children, className = '', bordered = true, variant = 'default' }) => {
  if (variant === 'gradient') {
    return (
      <div
        className={`rounded-t-xl border-b border-white/15 bg-gradient-to-r from-primary-800 via-primary-700 to-secondary-700 px-4 py-3 text-white shadow-[inset_0_-1px_0_0_rgba(0,0,0,0.08)] sm:px-5 sm:py-3.5 ${className}`}
      >
        {children}
      </div>
    );
  }
  return (
    <div className={`px-4 py-3 sm:px-5 sm:py-3.5 ${bordered ? 'border-b border-slate-100' : ''} ${className}`}>
      {children}
    </div>
  );
};

export const CardBody = ({ children, className = '' }) => {
  return (
    <div className={`p-4 sm:p-5 ${className}`}>
      {children}
    </div>
  );
};

export const CardFooter = ({ children, className = '' }) => {
  return (
    <div className={`px-4 py-3 sm:px-5 sm:py-3.5 bg-slate-50/60 border-t border-slate-100 rounded-b-xl ${className}`}>
      {children}
    </div>
  );
};

export const CardTitle = ({ children, className = '' }) => {
  return (
    <h3 className={`text-base font-semibold text-slate-900 tracking-tight ${className}`}>
      {children}
    </h3>
  );
};

export const CardDescription = ({ children, className = '' }) => {
  return (
    <p className={`text-sm text-slate-500 ${className}`}>
      {children}
    </p>
  );
};

export default Card;
